/**
 * @generated SignedSource<<f3da5ee59195921d90e4f44d584c6493>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientClass = "CUSTOMER" | "MEMBER";
export type HomeInternalQuery$variables = {
  dateGTE: string;
  dateTimeGTE: string;
  memberId: string;
};
export type HomeInternalQuery$data = {
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly bookings?: {
          readonly count: number;
        } | null | undefined;
        readonly clientClass: ClientClass | null | undefined;
        readonly club: {
          readonly appCustomization: {
            readonly backgroundImage: {
              readonly publicId: string;
            } | null | undefined;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"BookTodayFragment_Facilities" | "FeaturedEventsFragment_club" | "MobileHeaderFragment_club">;
        };
        readonly eventSignUps?: {
          readonly count: number;
        } | null | undefined;
        readonly firstName?: string | null | undefined;
        readonly managedBookings?: {
          readonly count: number;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"CustomerSchedule_Bookings" | "MemberSchedule_Bookings" | "MemberSchedule_EventSignUps" | "PackageNeedsAttentionBanner_customer">;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"BookNow_session" | "SideNavBarFragment_session">;
  } | null | undefined;
};
export type HomeInternalQuery = {
  response: HomeInternalQuery$data;
  variables: HomeInternalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dateGTE"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dateTimeGTE"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientClass",
  "storageKey": null
},
v2 = [
  {
    "alias": "publicId",
    "args": null,
    "kind": "ScalarField",
    "name": "renderingKey",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "backgroundImage",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v5 = [
  {
    "kind": "Variable",
    "name": "dateTimeGte",
    "variableName": "dateTimeGTE"
  },
  (v4/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASC",
      "field": "DATE_TIME"
    }
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "BookingConnection",
  "kind": "LinkedField",
  "name": "bookings",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "BookingConnection",
  "kind": "LinkedField",
  "name": "managedBookings",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v11 = {
  "kind": "Variable",
  "name": "dateGte",
  "variableName": "dateGTE"
},
v12 = [
  (v11/*: any*/),
  (v4/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPrivate",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPublic",
  "storageKey": null
},
v18 = [
  (v15/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityBookable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsJoinable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canBookOnBusySlot",
    "storageKey": null
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLessonsEnabled",
  "storageKey": null
},
v22 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "patronAccess",
    "storageKey": null
  },
  (v15/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "PublicLessonsPermissionSet",
  "kind": "LinkedField",
  "name": "publicLessonsPermissionSet",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "PrivateLessonsPermissionSet",
  "kind": "LinkedField",
  "name": "privateLessonsPermissionSet",
  "plural": false,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v25 = {
  "kind": "Literal",
  "name": "saleAvailability",
  "value": "PUBLIC"
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plural",
  "storageKey": null
},
v27 = [
  (v26/*: any*/)
],
v28 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v29 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v30 = {
  "alias": null,
  "args": (v29/*: any*/),
  "kind": "ScalarField",
  "name": "signUpStatusForClient",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startOn",
  "storageKey": null
},
v33 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v34 = [
  (v20/*: any*/),
  (v15/*: any*/)
],
v35 = {
  "alias": null,
  "args": (v33/*: any*/),
  "concreteType": "EventTagConnection",
  "kind": "LinkedField",
  "name": "tags",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EventTagEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventTag",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v34/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "tags(first:1000)"
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "CourseBucket",
  "kind": "LinkedField",
  "name": "courseBucket",
  "plural": false,
  "selections": (v34/*: any*/),
  "storageKey": null
},
v37 = [
  (v20/*: any*/),
  (v36/*: any*/),
  (v15/*: any*/)
],
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "singular",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "FacilityCopyOverrides",
  "kind": "LinkedField",
  "name": "copyOverrides",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NounOverride",
      "kind": "LinkedField",
      "name": "course",
      "plural": false,
      "selections": (v27/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Department",
  "kind": "LinkedField",
  "name": "department",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v20/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v44 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "EventEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v15/*: any*/),
          {
            "alias": null,
            "args": (v29/*: any*/),
            "kind": "ScalarField",
            "name": "accessStatusForClient",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accessStatus",
            "storageKey": null
          },
          (v30/*: any*/),
          {
            "alias": null,
            "args": (v29/*: any*/),
            "concreteType": "EventSignUp",
            "kind": "LinkedField",
            "name": "signUpForClient",
            "plural": false,
            "selections": [
              (v31/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v32/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endOn",
            "storageKey": null
          },
          (v35/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "spotsAvailable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v33/*: any*/),
            "concreteType": "EventSessionConnection",
            "kind": "LinkedField",
            "name": "eventSessions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventSessionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventSession",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CourseConnection",
                        "kind": "LinkedField",
                        "name": "courses",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Course",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v37/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "event",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventSeries",
                            "kind": "LinkedField",
                            "name": "eventSeries",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "facility",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FacilityCopyOverrides",
                                    "kind": "LinkedField",
                                    "name": "copyOverrides",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "NounOverride",
                                        "kind": "LinkedField",
                                        "name": "course",
                                        "plural": false,
                                        "selections": [
                                          (v38/*: any*/),
                                          (v26/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v15/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v39/*: any*/),
                      (v40/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayTime",
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "eventSessions(first:1000)"
          },
          {
            "alias": null,
            "args": (v29/*: any*/),
            "concreteType": "EventSignUpWindow",
            "kind": "LinkedField",
            "name": "clientEligibleSignUpWindows",
            "plural": true,
            "selections": [
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "closesAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "opensAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EventSeries",
            "kind": "LinkedField",
            "name": "eventSeries",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v41/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Facility",
                "kind": "LinkedField",
                "name": "facility",
                "plural": false,
                "selections": [
                  (v42/*: any*/),
                  (v43/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v45 = [
  (v15/*: any*/)
],
v46 = {
  "kind": "InlineFragment",
  "selections": (v45/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Club",
  "kind": "LinkedField",
  "name": "club",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DepartmentConnection",
      "kind": "LinkedField",
      "name": "departments",
      "plural": false,
      "selections": (v7/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "package",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "billingType",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "packageDueDate",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "SquareCardOnFile",
  "kind": "LinkedField",
  "name": "squareCard",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expMonth",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expYear",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v51 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "REQUEST"
    ]
  }
],
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "liftAt",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestCloses",
  "storageKey": null
},
v54 = [
  (v15/*: any*/),
  (v13/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RequestConfig",
        "kind": "LinkedField",
        "name": "requestConfig",
        "plural": false,
        "selections": (v45/*: any*/),
        "storageKey": null
      }
    ],
    "type": "RequestRule",
    "abstractKey": null
  }
],
v55 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "clientCanFulfillRequests",
    "storageKey": null
  },
  (v15/*: any*/)
],
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "RoundConnection",
  "kind": "LinkedField",
  "name": "rounds",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            (v15/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "player",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                (v10/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Image",
                  "kind": "LinkedField",
                  "name": "profileImage",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                (v15/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v58 = [
  (v56/*: any*/)
],
v59 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "startSlot",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Agenda",
      "kind": "LinkedField",
      "name": "agenda",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "date",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TimeSlotConnection",
          "kind": "LinkedField",
          "name": "timeSlots",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstDateTime",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v15/*: any*/),
        {
          "alias": "configuredRequestRestrictions",
          "args": (v51/*: any*/),
          "concreteType": "AgendaBookingRulesConnection",
          "kind": "LinkedField",
          "name": "requestWindowBookingRules",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AgendaBookingRulesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                (v52/*: any*/),
                (v53/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": (v54/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                (v17/*: any*/),
                (v15/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PrivateBookingPermissionSet",
              "kind": "LinkedField",
              "name": "privateBookingPermissionSet",
              "plural": false,
              "selections": (v55/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PublicBookingPermissionSet",
              "kind": "LinkedField",
              "name": "publicBookingPermissionSet",
              "plural": false,
              "selections": (v55/*: any*/),
              "storageKey": null
            },
            (v14/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lessonsDisplayName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FacilityCopyOverrides",
              "kind": "LinkedField",
              "name": "copyOverrides",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NounOverride",
                  "kind": "LinkedField",
                  "name": "lesson",
                  "plural": false,
                  "selections": [
                    (v38/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v43/*: any*/),
            (v20/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "CourseConnection",
              "kind": "LinkedField",
              "name": "courses",
              "plural": false,
              "selections": (v7/*: any*/),
              "storageKey": null
            },
            (v15/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v15/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isSlot"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateTime",
          "storageKey": null
        },
        (v56/*: any*/),
        {
          "alias": "configuredRequestRestrictions",
          "args": (v51/*: any*/),
          "concreteType": "SlotBookingRulesConnection",
          "kind": "LinkedField",
          "name": "requestWindowBookingRules",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SlotBookingRulesEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                (v52/*: any*/),
                (v53/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "requestWindowBookingRules(type:[\"REQUEST\"])"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "holeOffset",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BookingConnection",
          "kind": "LinkedField",
          "name": "bookings",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BookingEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v13/*: any*/),
                    (v57/*: any*/),
                    (v15/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Course",
          "kind": "LinkedField",
          "name": "course",
          "plural": false,
          "selections": (v37/*: any*/),
          "storageKey": null
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v58/*: any*/),
      "type": "BucketTimeSlot",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v60 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isBooking"
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestScheduleBlockingScope",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "Request",
  "kind": "LinkedField",
  "name": "request",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "bookingRule",
      "plural": false,
      "selections": (v54/*: any*/),
      "storageKey": null
    },
    (v15/*: any*/),
    (v56/*: any*/)
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesIndex",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesCount",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "TimeSlot",
  "kind": "LinkedField",
  "name": "fullfillableSlots",
  "plural": true,
  "selections": (v45/*: any*/),
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "SlotConnection",
  "kind": "LinkedField",
  "name": "slots",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SlotEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v13/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": (v58/*: any*/),
              "type": "TimeSlot",
              "abstractKey": null
            },
            (v15/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v67 = {
  "kind": "InlineFragment",
  "selections": [
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "durationMins",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StaffProfileConnection",
      "kind": "LinkedField",
      "name": "instructors",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StaffProfileEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "StaffProfile",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v15/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StaffUser",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fullName",
                      "storageKey": null
                    },
                    (v15/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LessonBooking",
  "abstractKey": null
},
v68 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roomName",
      "storageKey": null
    }
  ],
  "type": "DiningBooking",
  "abstractKey": null
},
v69 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "BookingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v59/*: any*/),
          (v15/*: any*/),
          (v60/*: any*/),
          (v61/*: any*/),
          (v57/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v31/*: any*/),
              (v66/*: any*/)
            ],
            "type": "StandardBooking",
            "abstractKey": null
          },
          (v67/*: any*/),
          (v68/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v70 = [
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "BookingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v13/*: any*/),
          (v59/*: any*/),
          (v15/*: any*/),
          (v60/*: any*/),
          (v61/*: any*/),
          (v57/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventRegistrationConnection",
                "kind": "LinkedField",
                "name": "eventRegistrations",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v31/*: any*/),
              (v66/*: any*/)
            ],
            "type": "StandardBooking",
            "abstractKey": null
          },
          (v67/*: any*/),
          (v68/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HomeInternalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookNow_session"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SideNavBarFragment_session"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "MobileHeaderFragment_club"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BookTodayFragment_Facilities"
                      },
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "dateGTE",
                            "variableName": "dateGTE"
                          }
                        ],
                        "kind": "FragmentSpread",
                        "name": "FeaturedEventsFragment_club"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppCustomization",
                        "kind": "LinkedField",
                        "name": "appCustomization",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PackageNeedsAttentionBanner_customer"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "CustomerSchedule_Bookings"
                      },
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "MemberSchedule_Bookings"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "MemberSchedule_EventSignUps"
                      },
                      (v8/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": (v12/*: any*/),
                        "concreteType": "EventSignUpConnection",
                        "kind": "LinkedField",
                        "name": "eventSignUps",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "type": "Member",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomeInternalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityConnection",
                        "kind": "LinkedField",
                        "name": "facilities",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacilityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PublicBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "publicBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v18/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PrivateBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "privateBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v18/*: any*/),
                                    "storageKey": null
                                  },
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Department",
                                    "kind": "LinkedField",
                                    "name": "department",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v19/*: any*/),
                                      (v20/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v21/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "calendarStartDay",
                        "storageKey": null
                      },
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "logoImage",
                        "plural": false,
                        "selections": (v2/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppCustomization",
                        "kind": "LinkedField",
                        "name": "appCustomization",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExternalLink",
                            "kind": "LinkedField",
                            "name": "externalLinks",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DepartmentConnection",
                        "kind": "LinkedField",
                        "name": "departments",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DepartmentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Department",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "anyFacilityLessonsEnabled",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FacilityConnection",
                                    "kind": "LinkedField",
                                    "name": "facilities",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FacilityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Facility",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              (v23/*: any*/),
                                              (v24/*: any*/),
                                              (v15/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "anyFacilityEventsEnabled",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "standardPackages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "packageType",
                            "value": "STANDARD"
                          },
                          (v25/*: any*/)
                        ],
                        "concreteType": "PackageConnection",
                        "kind": "LinkedField",
                        "name": "packages",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": "packages(packageType:\"STANDARD\",saleAvailability:\"PUBLIC\")"
                      },
                      {
                        "alias": "memberships",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "packageType",
                            "value": "MEMBERSHIP"
                          },
                          (v25/*: any*/)
                        ],
                        "concreteType": "PackageConnection",
                        "kind": "LinkedField",
                        "name": "packages",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": "packages(packageType:\"MEMBERSHIP\",saleAvailability:\"PUBLIC\")"
                      },
                      (v17/*: any*/),
                      (v16/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ClubCopyOverrides",
                        "kind": "LinkedField",
                        "name": "copyOverrides",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "event",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NounOverride",
                            "kind": "LinkedField",
                            "name": "lesson",
                            "plural": false,
                            "selections": (v27/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "featuredEvents",
                        "args": [
                          (v11/*: any*/),
                          (v28/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "isFeatured",
                            "value": true
                          }
                        ],
                        "concreteType": "EventConnection",
                        "kind": "LinkedField",
                        "name": "events",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "nonFeaturedEvents",
                        "args": [
                          (v11/*: any*/),
                          (v28/*: any*/),
                          {
                            "kind": "Literal",
                            "name": "isFeatured",
                            "value": false
                          }
                        ],
                        "concreteType": "EventConnection",
                        "kind": "LinkedField",
                        "name": "events",
                        "plural": false,
                        "selections": (v44/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  (v46/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v47/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": "activePackages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "status",
                            "value": "ACTIVE"
                          }
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberPackageEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberPackage",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v48/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderConnection",
                                    "kind": "LinkedField",
                                    "name": "orders",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrderEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Order",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v31/*: any*/),
                                              (v49/*: any*/),
                                              (v15/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v50/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "memberPackages(status:\"ACTIVE\")"
                      },
                      {
                        "alias": "upcomingPackages",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "status",
                            "value": "UPCOMING"
                          }
                        ],
                        "concreteType": "MemberPackageConnection",
                        "kind": "LinkedField",
                        "name": "memberPackages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberPackageEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MemberPackage",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v48/*: any*/),
                                  (v15/*: any*/),
                                  (v50/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrderConnection",
                                    "kind": "LinkedField",
                                    "name": "orders",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OrderEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Order",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v49/*: any*/),
                                              (v15/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "memberPackages(status:\"UPCOMING\")"
                      },
                      {
                        "alias": null,
                        "args": (v5/*: any*/),
                        "concreteType": "BookingConnection",
                        "kind": "LinkedField",
                        "name": "bookings",
                        "plural": false,
                        "selections": (v69/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v5/*: any*/),
                        "concreteType": "BookingConnection",
                        "kind": "LinkedField",
                        "name": "managedBookings",
                        "plural": false,
                        "selections": (v69/*: any*/),
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v15/*: any*/),
                      (v47/*: any*/),
                      {
                        "alias": null,
                        "args": (v5/*: any*/),
                        "concreteType": "BookingConnection",
                        "kind": "LinkedField",
                        "name": "bookings",
                        "plural": false,
                        "selections": (v70/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v5/*: any*/),
                        "concreteType": "BookingConnection",
                        "kind": "LinkedField",
                        "name": "managedBookings",
                        "plural": false,
                        "selections": (v70/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v12/*: any*/),
                        "concreteType": "EventSignUpConnection",
                        "kind": "LinkedField",
                        "name": "eventSignUps",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EventSignUpEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "EventSignUp",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "BookingConnection",
                                    "kind": "LinkedField",
                                    "name": "bookings",
                                    "plural": false,
                                    "selections": (v7/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Event",
                                    "kind": "LinkedField",
                                    "name": "event",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v32/*: any*/),
                                      (v35/*: any*/),
                                      (v30/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventSeries",
                                        "kind": "LinkedField",
                                        "name": "eventSeries",
                                        "plural": false,
                                        "selections": [
                                          (v20/*: any*/),
                                          (v41/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Facility",
                                            "kind": "LinkedField",
                                            "name": "facility",
                                            "plural": false,
                                            "selections": [
                                              (v20/*: any*/),
                                              (v42/*: any*/),
                                              (v43/*: any*/),
                                              (v15/*: any*/)
                                            ],
                                            "storageKey": null
                                          },
                                          (v15/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "EventSessionConnection",
                                        "kind": "LinkedField",
                                        "name": "eventSessions",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "EventSessionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "EventSession",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v39/*: any*/),
                                                  (v40/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "CourseConnection",
                                                    "kind": "LinkedField",
                                                    "name": "courses",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "concreteType": "CourseEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Course",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v15/*: any*/),
                                                              (v20/*: any*/),
                                                              (v36/*: any*/)
                                                            ],
                                                            "storageKey": null
                                                          }
                                                        ],
                                                        "storageKey": null
                                                      }
                                                    ],
                                                    "storageKey": null
                                                  },
                                                  (v15/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v13/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v10/*: any*/)
                    ],
                    "type": "Member",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v46/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v45/*: any*/),
                "type": "MemberProfile",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "staffAccessAvailable",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "activeMemberProfiles",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "active",
                        "value": true
                      },
                      {
                        "kind": "Literal",
                        "name": "hidden",
                        "value": false
                      }
                    ],
                    "concreteType": "MemberProfileConnection",
                    "kind": "LinkedField",
                    "name": "memberProfiles",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MemberProfileEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "MemberProfile",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hidden",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "member",
                                "plural": false,
                                "selections": [
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      (v19/*: any*/),
                                      (v15/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v46/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "memberProfiles(active:true,hidden:false)"
                  }
                ],
                "type": "MemberUser",
                "abstractKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f3ec16217fe322318d2a12d53f413c3d",
    "id": null,
    "metadata": {},
    "name": "HomeInternalQuery",
    "operationKind": "query",
    "text": "query HomeInternalQuery(\n  $dateGTE: Date!\n  $dateTimeGTE: Datetime!\n  $memberId: ID!\n) {\n  session {\n    ...BookNow_session\n    ...SideNavBarFragment_session\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        clientClass\n        club {\n          ...MobileHeaderFragment_club\n          ...BookTodayFragment_Facilities\n          ...FeaturedEventsFragment_club_L3UVj\n          appCustomization {\n            backgroundImage {\n              publicId: renderingKey\n            }\n            id\n          }\n          id\n        }\n        ... on Customer {\n          ...PackageNeedsAttentionBanner_customer\n          ...CustomerSchedule_Bookings\n          bookings(dateTimeGte: $dateTimeGTE, first: 100, orderBy: {field: DATE_TIME, direction: ASC}) {\n            count\n          }\n          managedBookings(dateTimeGte: $dateTimeGTE, first: 100, orderBy: {field: DATE_TIME, direction: ASC}) {\n            count\n          }\n          firstName\n        }\n        ... on Member {\n          ...MemberSchedule_Bookings\n          ...MemberSchedule_EventSignUps\n          bookings(dateTimeGte: $dateTimeGTE, first: 100, orderBy: {field: DATE_TIME, direction: ASC}) {\n            count\n          }\n          managedBookings(dateTimeGte: $dateTimeGTE, first: 100, orderBy: {field: DATE_TIME, direction: ASC}) {\n            count\n          }\n          eventSignUps(dateGte: $dateGTE, first: 100) {\n            count\n          }\n          firstName\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment BookButtonHomeHeader_session on Session {\n  ...BookModal_session\n}\n\nfragment BookModal_session on Session {\n  ...BookNow_session\n}\n\nfragment BookNow_session on Session {\n  ...ScheduleSwitcher_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        ...useGetClubStartOfWeekNumberPatron_club\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment BookTodayFragment_Facilities on Club {\n  ...useGetBookTodayData_club\n}\n\nfragment BookingCard_Booking on Booking {\n  __isBooking: __typename\n  __typename\n  id\n  requestScheduleBlockingScope\n  ...useShouldPresentBookingAsLockedRequest_booking\n  rounds {\n    edges {\n      node {\n        __typename\n        id\n        player {\n          __typename\n          firstName\n          lastName\n          profileImage {\n            publicId: renderingKey\n          }\n          id\n        }\n      }\n    }\n  }\n  startSlot {\n    __typename\n    ...useHasUnpublishedRequestRestrictions_slot\n    agenda {\n      date\n      facility {\n        club {\n          supportsPublic\n          id\n        }\n        privateBookingPermissionSet {\n          clientCanFulfillRequests\n          id\n        }\n        publicBookingPermissionSet {\n          clientCanFulfillRequests\n          id\n        }\n        type\n        lessonsDisplayName\n        copyOverrides {\n          lesson {\n            singular\n          }\n        }\n        department {\n          type\n          name\n          id\n        }\n        name\n        courses {\n          count\n        }\n        id\n      }\n      id\n    }\n    ... on TimeSlot {\n      time\n      groupLabel\n      holeOffset\n      bookings {\n        edges {\n          node {\n            __typename\n            rounds {\n              edges {\n                node {\n                  __typename\n                  id\n                  player {\n                    __typename\n                    firstName\n                    lastName\n                    profileImage {\n                      publicId: renderingKey\n                    }\n                    id\n                  }\n                }\n              }\n            }\n            id\n          }\n        }\n      }\n      course {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n    }\n    ... on BucketTimeSlot {\n      time\n    }\n    id\n  }\n  ... on StandardBooking {\n    seriesIndex\n    seriesCount\n    fullfillableSlots {\n      id\n    }\n    status\n    slots {\n      edges {\n        node {\n          __typename\n          ... on TimeSlot {\n            time\n          }\n          id\n        }\n      }\n    }\n    request {\n      time\n      id\n    }\n  }\n  ... on LessonBooking {\n    seriesIndex\n    seriesCount\n    durationMins\n    request {\n      time\n      id\n    }\n    instructors {\n      edges {\n        node {\n          id\n          user {\n            fullName\n            id\n          }\n        }\n      }\n    }\n  }\n  ... on DiningBooking {\n    roomName\n  }\n}\n\nfragment CustomerSchedule_Bookings on Customer {\n  id\n  club {\n    departments {\n      count\n    }\n    id\n  }\n  bookings(dateTimeGte: $dateTimeGTE, first: 100, orderBy: {field: DATE_TIME, direction: ASC}) {\n    count\n    edges {\n      node {\n        __typename\n        startSlot {\n          __typename\n          agenda {\n            date\n            timeSlots {\n              firstDateTime\n            }\n            id\n          }\n          ... on TimeSlot {\n            dateTime\n            time\n          }\n          id\n        }\n        id\n        ...BookingCard_Booking\n      }\n    }\n  }\n  managedBookings(dateTimeGte: $dateTimeGTE, first: 100, orderBy: {field: DATE_TIME, direction: ASC}) {\n    count\n    edges {\n      node {\n        __typename\n        startSlot {\n          __typename\n          agenda {\n            date\n            timeSlots {\n              firstDateTime\n            }\n            id\n          }\n          ... on TimeSlot {\n            dateTime\n            time\n          }\n          id\n        }\n        id\n        ...BookingCard_Booking\n      }\n    }\n  }\n}\n\nfragment DepartmentCard_department on Department {\n  id\n  name\n  slug\n  type\n}\n\nfragment EventCardWrapper_Event on Event {\n  id\n  accessStatusForClient(clientId: $memberId)\n  accessStatus\n  signUpStatusForClient(clientId: $memberId)\n  signUpForClient(clientId: $memberId) {\n    status\n    id\n  }\n  startOn\n  endOn\n  tags(first: 1000) {\n    edges {\n      node {\n        name\n        id\n      }\n    }\n  }\n  spotsAvailable\n  eventSessions(first: 1000) {\n    edges {\n      node {\n        ...useEventLocationLabel_Event\n        startAt\n        endAt\n        displayTime\n        courses {\n          edges {\n            node {\n              id\n              name\n              courseBucket {\n                name\n                id\n              }\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n  clientEligibleSignUpWindows(clientId: $memberId) {\n    id\n    closesAt\n    opensAt\n  }\n  eventSeries {\n    name\n    color\n    facility {\n      copyOverrides {\n        course {\n          plural\n        }\n      }\n      department {\n        type\n        name\n        id\n      }\n      id\n    }\n    image {\n      publicId: renderingKey\n    }\n    id\n  }\n}\n\nfragment EventSignUpCardWrapper_EventSignUp on EventSignUp {\n  id\n  bookings {\n    count\n  }\n  event {\n    id\n    startOn\n    tags(first: 1000) {\n      edges {\n        node {\n          name\n          id\n        }\n      }\n    }\n    signUpStatusForClient(clientId: $memberId)\n    eventSeries {\n      name\n      color\n      facility {\n        name\n        copyOverrides {\n          course {\n            plural\n          }\n        }\n        department {\n          type\n          name\n          id\n        }\n        id\n      }\n      id\n    }\n    eventSessions {\n      edges {\n        node {\n          startAt\n          endAt\n          courses {\n            edges {\n              node {\n                id\n                name\n                courseBucket {\n                  name\n                  id\n                }\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment EventsList_EventsConnection on EventConnection {\n  edges {\n    node {\n      id\n      ...EventCardWrapper_Event\n    }\n  }\n}\n\nfragment FacilityCard_Facility on Facility {\n  id\n  name\n  slug\n  type\n  ...getFacilityMemberPermissions_facility\n  department {\n    type\n    id\n  }\n}\n\nfragment FacilityLogoFragment_club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment FacilityLogoSideNavFragment_club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment FeaturedEventsFragment_club_L3UVj on Club {\n  departments {\n    edges {\n      node {\n        anyFacilityEventsEnabled\n        id\n      }\n    }\n  }\n  copyOverrides {\n    event {\n      plural\n    }\n  }\n  featuredEvents: events(first: 5, dateGte: $dateGTE, isFeatured: true) {\n    count\n    ...EventsList_EventsConnection\n  }\n  nonFeaturedEvents: events(first: 5, dateGte: $dateGTE, isFeatured: false) {\n    count\n    ...EventsList_EventsConnection\n  }\n}\n\nfragment HomeHeaderFragment_session on Session {\n  ...BookButtonHomeHeader_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        id\n        name\n        ...FacilityLogoSideNavFragment_club\n        appCustomization {\n          backgroundImage {\n            publicId: renderingKey\n          }\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment MemberSchedule_Bookings on Member {\n  id\n  club {\n    departments {\n      count\n    }\n    id\n  }\n  bookings(dateTimeGte: $dateTimeGTE, first: 100, orderBy: {field: DATE_TIME, direction: ASC}) {\n    count\n    edges {\n      node {\n        ... on StandardBooking {\n          eventRegistrations {\n            count\n          }\n        }\n        __typename\n        startSlot {\n          __typename\n          agenda {\n            date\n            timeSlots {\n              firstDateTime\n            }\n            id\n          }\n          ... on TimeSlot {\n            dateTime\n            time\n          }\n          id\n        }\n        id\n        ...BookingCard_Booking\n      }\n    }\n  }\n  managedBookings(dateTimeGte: $dateTimeGTE, first: 100, orderBy: {field: DATE_TIME, direction: ASC}) {\n    count\n    edges {\n      node {\n        ... on StandardBooking {\n          eventRegistrations {\n            count\n          }\n        }\n        __typename\n        startSlot {\n          __typename\n          agenda {\n            date\n            timeSlots {\n              firstDateTime\n            }\n            id\n          }\n          ... on TimeSlot {\n            dateTime\n            time\n          }\n          id\n        }\n        id\n        ...BookingCard_Booking\n      }\n    }\n  }\n}\n\nfragment MemberSchedule_EventSignUps on Member {\n  id\n  club {\n    departments {\n      count\n    }\n    id\n  }\n  eventSignUps(dateGte: $dateGTE, first: 100) {\n    count\n    edges {\n      node {\n        ...EventSignUpCardWrapper_EventSignUp\n        id\n        __typename\n        event {\n          startOn\n          eventSessions {\n            edges {\n              node {\n                startAt\n                id\n              }\n            }\n          }\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment MobileHeaderFragment_club on Club {\n  ...FacilityLogoFragment_club\n  name\n}\n\nfragment PackageNeedsAttentionBanner_customer on Customer {\n  id\n  ...useGetPackageNeedingAttention_customer\n}\n\nfragment ScheduleSwitcher_session on Session {\n  ...useGetScheduleSwitcherOptionsFragment_session\n}\n\nfragment SideNavBarFragment_session on Session {\n  ...HomeHeaderFragment_session\n  ...useGetSideNavBarItemsFragment_session\n}\n\nfragment departmentToScheduleOption_department on Department {\n  type\n  id\n  slug\n  name\n}\n\nfragment facilityToScheduleOption_facility on Facility {\n  id\n  slug\n  name\n  type\n  department {\n    type\n    id\n  }\n}\n\nfragment getFacilityMemberPermissions_facility on Facility {\n  club {\n    id\n    supportsPrivate\n    supportsPublic\n  }\n  publicBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n  privateBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n}\n\nfragment packageMissingPaymentMethod_memberPackage on MemberPackage {\n  squareCard {\n    id\n  }\n  package {\n    __typename\n    billingType\n    id\n  }\n}\n\nfragment packageOrderNeedsPayment_order on Order {\n  status\n  packageDueDate\n}\n\nfragment packagePaymentMethodExpired_memberPackage on MemberPackage {\n  package {\n    __typename\n    billingType\n    id\n  }\n  orders {\n    edges {\n      node {\n        packageDueDate\n        id\n      }\n    }\n  }\n  squareCard {\n    id\n    expMonth\n    expYear\n  }\n}\n\nfragment useCurrentClubHasVisibleLessons_session on Session {\n  ...useIsCurrentUserPublic_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        departments {\n          edges {\n            node {\n              anyFacilityLessonsEnabled\n              facilities {\n                edges {\n                  node {\n                    isLessonsEnabled\n                    publicLessonsPermissionSet {\n                      patronAccess\n                      id\n                    }\n                    privateLessonsPermissionSet {\n                      patronAccess\n                      id\n                    }\n                    id\n                  }\n                }\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useEventLocationLabel_Event on EventSession {\n  courses {\n    edges {\n      node {\n        name\n        courseBucket {\n          name\n          id\n        }\n        id\n      }\n    }\n  }\n  event {\n    eventSeries {\n      facility {\n        ...useFacilityCourseNoun_facility\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment useFacilityCourseNoun_facility on Facility {\n  copyOverrides {\n    course {\n      singular\n      plural\n    }\n  }\n}\n\nfragment useGetBookTodayData_club on Club {\n  facilities {\n    edges {\n      node {\n        id\n        type\n        ...getFacilityMemberPermissions_facility\n        ...FacilityCard_Facility\n        department {\n          id\n          ...DepartmentCard_department\n        }\n      }\n    }\n  }\n}\n\nfragment useGetClubStartOfWeekNumberPatron_club on Club {\n  calendarStartDay\n}\n\nfragment useGetPackageNeedingAttention_customer on Customer {\n  activePackages: memberPackages(status: ACTIVE) {\n    edges {\n      node {\n        id\n        package {\n          __typename\n          id\n        }\n        orders {\n          edges {\n            node {\n              ...packageOrderNeedsPayment_order\n              id\n            }\n          }\n        }\n        ...packageMissingPaymentMethod_memberPackage\n        ...packagePaymentMethodExpired_memberPackage\n      }\n    }\n  }\n  upcomingPackages: memberPackages(status: UPCOMING) {\n    edges {\n      node {\n        package {\n          __typename\n          id\n        }\n        id\n        ...packageMissingPaymentMethod_memberPackage\n        ...packagePaymentMethodExpired_memberPackage\n      }\n    }\n  }\n}\n\nfragment useGetScheduleSwitcherOptionsFragment_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        facilities {\n          edges {\n            node {\n              type\n              id\n              ...getFacilityMemberPermissions_facility\n              ...facilityToScheduleOption_facility\n              department {\n                id\n                type\n                ...departmentToScheduleOption_department\n              }\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useGetSideNavBarItemsFragment_session on Session {\n  staffAccessAvailable\n  ...useGoToStore_session\n  ...useCurrentClubHasVisibleLessons_session\n  ...useLessonTabHandler_session\n  user {\n    __typename\n    ... on MemberUser {\n      activeMemberProfiles: memberProfiles(active: true, hidden: false) {\n        count\n        edges {\n          node {\n            hidden\n            member {\n              __typename\n              club {\n                slug\n                id\n              }\n              ... on Node {\n                __isNode: __typename\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n  currentClientProfile {\n    __typename\n    ... on MemberProfile {\n      id\n    }\n    member {\n      __typename\n      club {\n        ...useIsClubSellingStandardPackages_club\n        ...useIsClubSellingMemberships_club\n        supportsPublic\n        supportsPrivate\n        slug\n        copyOverrides {\n          event {\n            plural\n          }\n          lesson {\n            plural\n          }\n        }\n        appCustomization {\n          externalLinks {\n            displayName\n            url\n          }\n          id\n        }\n        departments {\n          edges {\n            node {\n              anyFacilityEventsEnabled\n              anyFacilityLessonsEnabled\n              id\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useGoToStore_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        club {\n          ...useIsClubSellingStandardPackages_club\n          ...useIsClubSellingMemberships_club\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useHasUnpublishedRequestRestrictions_slot on Slot {\n  __isSlot: __typename\n  __typename\n  ... on QueueSlot {\n    agenda {\n      configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n        edges {\n          liftAt\n          requestCloses\n        }\n      }\n      id\n    }\n  }\n  ... on TimeSlot {\n    configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n      edges {\n        liftAt\n        requestCloses\n      }\n    }\n  }\n}\n\nfragment useIsClubSellingMemberships_club on Club {\n  memberships: packages(packageType: MEMBERSHIP, saleAvailability: PUBLIC) {\n    count\n  }\n}\n\nfragment useIsClubSellingStandardPackages_club on Club {\n  standardPackages: packages(packageType: STANDARD, saleAvailability: PUBLIC) {\n    count\n  }\n}\n\nfragment useIsCurrentUserPublic_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      clientClass\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useLessonTabHandler_session on Session {\n  ...useIsCurrentUserPublic_session\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        facilities {\n          edges {\n            node {\n              slug\n              isLessonsEnabled\n              publicLessonsPermissionSet {\n                patronAccess\n                id\n              }\n              privateLessonsPermissionSet {\n                patronAccess\n                id\n              }\n              id\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useShouldPresentBookingAsLockedRequest_booking on Booking {\n  __isBooking: __typename\n  startSlot {\n    __typename\n    agenda {\n      configuredRequestRestrictions: requestWindowBookingRules(type: [REQUEST]) {\n        edges {\n          liftAt\n          requestCloses\n          node {\n            id\n            __typename\n            ... on RequestRule {\n              requestConfig {\n                id\n              }\n            }\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n  ... on StandardBooking {\n    request {\n      bookingRule {\n        id\n        __typename\n        ... on RequestRule {\n          requestConfig {\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n  ... on LessonBooking {\n    request {\n      bookingRule {\n        id\n        __typename\n        ... on RequestRule {\n          requestConfig {\n            id\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "512c90cf99156e072848c673ed6c2eda";

export default node;
